import { MarktingCard } from "../../AvatarDigitalMarketer/AiMarketingTeam";
import Box from "../../components/Box";

export const schoolBenefits = [{
    title: "Better Scores",
    description: "Marks improve naturally when mindset is steady",
    cName: "text-center"
}, {
    title: "Less Anxiety",
    description: "Exam fear drops and confidence rises",
    cName: "text-center"
}, {
    title: "Higher Admissions",
    description: "Trust and parent engagement lead to organic growth",
    cName: "text-center"
}];


export default function Mindset() {

    return (
            <Box
                badge={"OUR EQUATION"}
                parentClass="bg-[white] p-8 rounded-xl"
                title={"Mindset + Academics = Excellence"}
                description={"A short intro to the problem and the emotional tone. The full content is built for long-form storytelling that inspires school leaders to act."}
                leftBlock={
                    <div className='col-span-2 md:col-span-1'>
                        {/* <div className="grid grid-cols-3 mt-8 gap-6"> */}
                        <div className="grid grid-cols-3 md:grid-cols-1 gap-6">
                            {schoolBenefits.slice(0, 3).map((member, index) => <MarktingCard key={"memberasdsadInnerCard" + index} member={member} />)}
                        </div>
                    </div>
                }
                rightBlock={<div className='col-span-2 md:col-span-1'>
                    <div className="bg-[#ECECF7] border border-[#ECECF7] rounded-xl p-2 text-center text-sm font-medium">
                        “When students begin each day emotionally strong, the learning curve transforms for everyone — students, teachers, and parents."
                    </div>
                </div>}
            />
    );
}